/** @jsxImportSource @emotion/react */
import { useState } from 'react'
import tw, { styled } from 'twin.macro'
import useLocalization from '../../hooks/useLocalization'
import Container from '@mui/material/Container';
import Locales from "../../data/locale.json"
import InfoIcon from '@mui/icons-material/Info';
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import { PortalWithState } from 'react-portal';
import InformationPanel from '../InformationPanel';
import { useEffect } from 'react';

const Header = () => {
  const { t, lang } = useLocalization();
  const [ currentLang , setCurrentLang ] = useState(lang)

  useEffect(() => {
    setCurrentLang(lang);
  },[lang])


  return(
  <>
    <Helmet>
      <title>{t(`sitename`)}</title>
      <meta name="description" content={t(`siteDescription`)} />
      <meta property="og:title" content={t(`sitename`)} />
      <meta property="og:description" content={t(`siteDescription`)} />
      <meta name="twitter:title" content={t(`sitename`)} />
      <meta name="twitter:description" content={t(`siteDescription`)} />
    </Helmet>
    <HeaderWrapper>
      <HeaderContent>
        <SiteName>{t(`sitename`)}</SiteName>
        <LangSwitcher>
          {Object.keys(Locales).map((item) => <LangButton key={`lang_${item}`} to={`/${Locales[item].code}`} className={currentLang === item ? `current` : ``}>{Locales[item].label}</LangButton>)}
          <PortalWithState closeOnOutsideClick closeOnEsc>
            {({ openPortal, closePortal, isOpen, portal }) => (
              <>
                <InfoButton onClick={openPortal}><InfoIcon fontSize={'small'}/></InfoButton>
                {portal(<InformationPanel closePortal={closePortal} isOpen={isOpen}/>)}
              </>
            )}
          </PortalWithState>
        </LangSwitcher>
      </HeaderContent>
    </HeaderWrapper>
  </>)
}

export default Header

const HeaderWrapper = styled.div`
  ${tw`
    bg-gray-800
    w-full
    h-8
    leading-8
    text-white
  `}
`

const HeaderContent = styled(Container)`
  ${tw`
    flex
    mx-auto
    justify-between
  `}
`

const SiteName = styled.div`
  ${tw`
    text-[12px]
  `}
`

const LangSwitcher = styled.div`
  ${tw`
    flex
    gap-1
  `}
`

const LangButton = styled(Link)`
  ${tw`
    block
    text-[12px]
    px-2
    cursor-pointer
    hover:bg-[#666666]
  `}

  &.current{
    ${tw`
      bg-[#AAAAAA]
    `}
  }
`

const InfoButton = styled.a`
  ${tw`
  block
  hover:bg-[#666666]
  px-2
  `}
`